import { useStatsigClient } from '@statsig/react-bindings'
import { useMemo } from 'react'
import { resolveUserPreferencesScope } from '../utility/userPreferencesApi'

/**
 * Resolves org-scoped user_preferences query scope from Statsig gate + active Clerk org.
 * @param {{ orgId?: string | null }} [options]
 * @returns {{ orgScoped: boolean, orgId: string | null }} Gate-aware scope for user_preferences queries.
 */
export function useUserPreferencesScope(options = {}) {
  const { orgId: orgIdOverride = null } = options
  const { client: statsigClient } = useStatsigClient()

  return useMemo(
    () =>
      resolveUserPreferencesScope({
        checkGate: statsigClient.checkGate.bind(statsigClient),
        orgId: orgIdOverride,
      }),
    [statsigClient, orgIdOverride],
  )
}
